export default __webpack_public_path__ + "static/media/coreWebVitalsOptimization.d11fcc11.md";